const routes = [
    {
        path: "/catering/requests",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'cateringform_index'
        },
    },
    {
        path: "/catering/request/:id",
        component: () => import("../pages/Detail.vue"),
        meta: {
            isAuthenticated: true,
            permission: "cateringform_show"
        }
    },
    {
        path: "/catering/request-form",
        component: () => import("../pages/InstructorForm.vue"),
        meta: {
            isAuthenticated: true,
            isStaff: true
        },
    },
];

export default routes;
